import * as React from "react";
import { AbstractDate } from "@linkfluence/models/date";
import { Locale } from "@linkfluence/models/locale";
import { Timezone } from "@linkfluence/models/timezone";
import { travel, tz } from ".";

interface IProps {
  date: AbstractDate;
  timezone?: Timezone;
  locale: Locale;
}

const Component = ({ date, timezone, locale }: IProps) => {
  travel(locale);
  return <>{tz(date, timezone).fromNow()}</>;
};

export default Component;
